import { gql } from '@apollo/client';

export const VR_PAIR = gql`
  mutation activateMagicCode($Code: String!) {
    activateMagicCode(Code: $Code) {
      ID
    }
  }
`;
